module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/vectors/term-bg-1-9070af5ae2870f2cf7586124cf78dfd2.jpg";